import {
    undef,
    allowFieldAutoProgress,
    allowInputFieldErrorHighlighting,
    runHPDestinationEmptySearchErrorExperiment
} from './';

function getDestinationValuesFilter({subDestination}) {
    return (
        subDestination && subDestination.filter
            ? subDestination.filter.id
            : null
    );
}

function hasEmptyDestination(destination) {
    return !destination;
}

function hasEmptyDestinationValues({destination}) {
    return hasEmptyDestination(destination);
}

function hasFilledDestination(destination) {
    return !hasEmptyDestination(destination);
}

/* istanbul ignore next */
function hasFilledDestinationValues({destination}) {
    return hasFilledDestination(destination);
}

function hasValidDestination(destination) {
    return hasFilledDestination(destination);
}

function hasValidDestinationValues({destination}) {
    return hasValidDestination(destination);
}

function hasListingDestinationValues({listingProps}) {
    return !!listingProps;
}

function shouldDestinationFieldAutoProgressOnSearchSelected(mediaSettings, formOptions, destinationOptions, changedValues) {
    const {
        isMobile
    } = mediaSettings;

    return (
        !isMobile &&
        allowFieldAutoProgress(formOptions, destinationOptions) &&
        hasValidDestinationValues(changedValues)
    );
}

function showDestinationInputFieldError(mediaSettings, formOptions, formSettings, destinationOptions, latestDestinationValues, abacusStore, systemOptions) {
    const {
        isMobile
    } = mediaSettings;

    return !isMobile && (
        allowInputFieldErrorHighlighting(formOptions, destinationOptions) && !hasValidDestinationValues(latestDestinationValues) ||
        runHPDestinationEmptySearchErrorExperiment(abacusStore, systemOptions, formSettings, latestDestinationValues)
    );
}

function showDestinationIcon(formOptions, destinationOptions) {
    const {
        showIcons
    } = formOptions;

    const {
        showIcon
    } = destinationOptions;

    return (
        showIcon ||
        showIcons && showIcon === undef
    );
}

export {
    getDestinationValuesFilter,
    hasEmptyDestination,
    hasEmptyDestinationValues,
    hasFilledDestination,
    hasFilledDestinationValues,
    hasValidDestination,
    hasValidDestinationValues,
    hasListingDestinationValues,
    shouldDestinationFieldAutoProgressOnSearchSelected,
    showDestinationInputFieldError,
    showDestinationIcon
};
